import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CaregiverService, ModalService, PatientService, UserService, ValidateService} from '../../services';
import {TranslateService} from '@ngx-translate/core';
import {Location} from '@angular/common';
import {environment} from '../../../../environments/environment';
import { zonedDate } from '../../zoned-time';

@Component({
  selector: 'app-pop-up-reports-user',
  templateUrl: './pop-up-reports-user.component.html',
  styleUrls: ['./pop-up-reports-user.component.scss']
})
export class PopUpReportsUserComponent implements OnInit  {

  generateRaportForm: FormGroup;
  isSubmitting = false;
  errors: any = { errors: {} };
  showDatePicker = false;
  showNoteField = false;
  imei: string;
  timeZone: string;

  constructor(
    private fb: FormBuilder,
    private patientService: PatientService,
    private translate: TranslateService,
    private modalService: ModalService,
    private validateService: ValidateService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.generateRaportForm = this.fb.group({
      'from': '',
      'to': '',
      'lang': '',
      'pulse': false,
      'sat': false,
      'sdnn': false,
      'drugs': false,
      'alerts': false,
      'steps': false,
      'pressure': false,
      'sleep': false,
      'note': ['', [Validators.maxLength(1024)]],
    });
  }

  toggleDatePicker(): void {
    this.showDatePicker = !this.showDatePicker;
  }

  toggleMetric(metricName: string): void {
    const currentValue = this.generateRaportForm.get(metricName).value;
    this.generateRaportForm.patchValue({
      [metricName]: !currentValue
    });
  }

  toggleNoteField(): void {
    this.showNoteField = !this.showNoteField;
  }

  formatDateRange(): string {
    const fromStruct = this.generateRaportForm.get('from').value;
    const toStruct = this.generateRaportForm.get('to').value;

    let from = this.structToIsoDate(fromStruct);
    let to = this.structToIsoDate(toStruct);

    if (!from || !to) {
      from = '1970-01-01';
      to = this.todayIso();
    }

    return `${from} - ${to}`;
  }

  private todayIso(): string {
    const today = zonedDate(Date.now(), this.timeZone);
    return `${today.getFullYear()}-${(today.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
  }

  private structToIsoDate(struct: any): string {
    if (!struct || !struct.year || !struct.month || !struct.day) return '';
    const month = struct.month.toString().padStart(2, '0');
    const day = struct.day.toString().padStart(2, '0');
    return `${struct.year}-${month}-${day}`;
  }

  getNotePreview(): string {
    const note = this.generateRaportForm.get('note').value;
    if (!note) return this.translate.instant('COMMON.PULSE_MEASUREMENTS_PLACEHOLDER');
    return note.length > 20 ? note.substring(0, 20) + '...' : note;
  }

  getSelectedCount(): number {
    let count = 0;
    const fields = ['pulse', 'sat', 'sdnn', 'drugs', 'alerts', 'steps', 'pressure', 'sleep'];
    fields.forEach(field => {
      if (this.generateRaportForm.get(field).value) {
        count++;
      }
    });
    return count;
  }

  public submitForm(): void {
    if (this.generateRaportForm.valid) {

      this.isSubmitting = true;
      this.errors = { errors: {} };
      const credentials = Object.assign({}, this.generateRaportForm.value);

      const fromIso = this.structToIsoDate(credentials.from);
      const toIso = this.structToIsoDate(credentials.to);

      if (!fromIso && !toIso) {
        credentials.from = `1970-01-01 00:00:00`;
        credentials.to = `${this.todayIso()} 23:59:59`;
      } else {
        credentials.from = fromIso ? `${fromIso} 00:00:00` : `1970-01-01 00:00:00`;
        credentials.to = `${toIso || this.todayIso()} 23:59:59`;
      }

      credentials.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'pl';
      credentials.timezone = this.timeZone;

      this.patientService
        .generateRaport(this.imei, credentials)
        .subscribe(
          data => {
            window.location.assign(environment.api_url + '/patient/download-report/' + data.link);
          },
          err => {
            this.errors = err;
            this.isSubmitting = false;
          },
          () => this.isSubmitting = false
        );

    } else {
      this.validateService.validateAllFormFields(this.generateRaportForm);
      this.modalService.open(this.translate.instant('BACKEND.ALL_FIELDS_REQUIRED'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.POP-UP-REPORTS-USER.POPUP.BACKEND-ALL_FIELDS_REQUIRED');
    }
  }



}
